<template>
  <div class="py-4 d-flex justify-content-center">
    <div class="w-100" style="max-width: 900px">
      <div class="card mx-auto shadow p-4" style="max-width: 1000px">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="mb-0">Popups Management</h3>
          <button class="btn btn-primary" @click="toggleForm">
            {{ showForm ? "Close Upload" : "Upload Pop-Up" }}
          </button>
        </div>

        <div class="text-end mb-3">
          <select
            v-model="selectedLang"
            @change="onLangChange"
            class="form-select w-auto d-inline-block"
          >
            <option
              v-for="lang in languages"
              :key="lang.code"
              :value="lang.code"
            >
              {{ lang.language }}
            </option>
          </select>

          <select
          v-model="selectedCountry"
          @change="onCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="count in countries"
            :key="count.code"
            :value="count.code"
          >
            {{ count.country }}
          </option>
        </select>
        </div>

        <!-- Upload Form -->
        <div v-if="showForm" class="mb-4 border p-3 rounded bg-light">
          <h5 class="mb-3">Upload New Pop-Up</h5>
          <form @submit.prevent="uploadPopup">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Start Date</label>
                <input
                  type="datetime-local"
                  v-model="form.start_date"
                  class="form-control"
                  required
                />
              </div>

              <div class="col-md-6">
                <label class="form-label">End Date</label>
                <input
                  type="datetime-local"
                  v-model="form.end_date"
                  class="form-control"
                  required
                />
              </div>

              <div class="col-md-6">
                <label class="form-label">Active</label>
                <select class="form-control" v-model="form.active" required>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <br />

              <div class="col-md-6">
                <label class="form-label">Link</label>
                <input
                  type="text"
                  v-model="form.link"
                  class="form-control"
                  required
                />
              </div>

              <div class="col-12">
                <label class="form-label">Upload Image</label>
                <input
                  type="file"
                  class="form-control"
                  @change="handleFileUpload"
                  required
                />
              </div>

              <div v-if="preview" class="col-12 text-center mt-2">
                <img
                  :src="preview"
                  class="img-fluid rounded"
                  style="max-height: 200px"
                />
              </div>

              <div class="col-12 text-end">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="loading"
                >
                  <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  <span v-else>Upload</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <!-- Popups List -->
        <div>
          <h5 class="mb-3">Uploaded Popups</h5>
          <div v-if="popups.length === 0">No popups found.</div>

          <div v-else class="list-group">
            <div
              v-for="popup in popups"
              :key="popup.id"
              class="list-group-item d-flex align-items-center justify-content-between"
            >
              <img
                :src="getPopUpUrl(popup.image_url)"
                alt="popup"
                width="100"
                class="img-thumbnail me-3"
              />
              <div class="flex-grow-1">
                <div>Start Date: {{ popup.start_date }}</div>
                <div>End Date: {{ popup.end_date }}</div>

                <div>
                  Status:
                  <span
                    :class="popup.active === 1 ? 'text-success' : 'text-danger'"
                  >
                    {{ popup.active === 1 ? "Active" : "Inactive" }}
                  </span>
                </div>
                <div>Link: {{ popup.link }}</div>
              </div>
              <div class="row p-2 m-2">
                <button
                  class="p-2 m-2 btn btn-sm btn-warning"
                  @click="prepareEdit(popup)"
                >
                  Edit
                </button>
                <button
                  class="p-2 m-2 btn btn-sm btn-danger"
                  @click="deletePopup(popup.id)"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Edit Modal -->
        <div
          v-if="editing"
          class="modal fade show d-block"
          tabindex="-1"
          style="background-color: rgba(0, 0, 0, 0.5)"
        >
          <div class="modal-dialog">
            <div class="modal-content w-100">
              <form @submit.prevent="submitEdit">
                <div class="modal-header">
                  <h5 class="modal-title text-black">Edit Pop-Up</h5>
                  <button
                    type="button"
                    class="btn-close"
                    @click="editing = null"
                  ></button>
                </div>
                <div class="modal-body">
                  <div class="mb-2">
                    <label class="form-label">Start Date</label>
                    <input
                      type="datetime-local"
                      v-model="editing.start_date"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="mb-2">
                    <label class="form-label">End Date</label>
                    <input
                      type="datetime-local"
                      v-model="editing.end_date"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="mb-2">
                    <label class="form-label">Active</label>
                    <select
                      class="form-control"
                      v-model.number="editing.active"
                      required
                    >
                      <option :value="1">Active</option>
                      <option :value="0">Inactive</option>
                    </select>
                  </div>
                  <div class="mb-2">
                    <label class="text-start">Link</label>
                    <input
                      type="text"
                      v-model="editing.link"
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="row p-2 m-2">
                  <button class="p-2 m-2 btn btn-primary" type="submit">
                    Save Changes
                  </button>
                  <button
                    class="p-2 m-2 btn btn-danger"
                    @click="editing = null"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      form: {
        start_date: "",
        end_date: "",
        active: "1",
        link: "",
        file: null,
      },
      selectedCountry: "CG",
      countries: [],
      selectedLang: "en", // default language
      preview: null,
      popups: [],
      languages: [],
      showForm: false,
      loading: false,
      editing: null,
    };
  },
  watch: {
    selectedLang(newLang) {
      this.fetchPopups(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.fetchPopups(this.selectedLang, newCountry);
    },
  },
  mounted() {
    this.getCountries();

    // this.fetchPopups();
    this.getLanguages();

// Ensure selectedCountry is valid after countries load
if (!this.selectedCountry && this.countries.length) {
  this.selectedCountry = this.countries[0].code;
}
// this.fetchPopups(this.selectedLang, this.selectedCountry);

  },
  methods: {
    async getCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    onLangChange() {
      this.fetchPopups(this.selectedLang, this.selectedCountry);
    },
    toggleForm() {
      this.showForm = !this.showForm;
    },
    handleFileUpload(e) {
      const file = e.target.files[0];
      this.form.file = file;
      this.preview = URL.createObjectURL(file);
    },
    async fetchPopups(lang, country) {
      try {
        const res = await axios.get(`/popups?lang=${lang}&country=${country}`, {
          headers: { "api-key": Cookies.get("authToken") },
        });
        this.popups = res.data.popups || [];
      } catch (err) {
        const status = err.response?.status;
        this.popups = [];
        if (status === 404) {
          this.$notify({
            message:
              err.response?.data?.message || err.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
        console.error("Error fetching popups", err);
      }
    },
    async uploadPopup() {
      const formData = new FormData();
      formData.append("file", this.form.file);
      formData.append("start_date", this.form.start_date);
      formData.append("end_date", this.form.end_date);
      formData.append("active", this.form.active);
      formData.append("link", this.form.link);
      formData.append("language", this.selectedLang);
      formData.append("country", this.selectedCountry);

      this.loading = true;
      try {
        const res = await axios.post("/popups", formData, {
          headers: {
            "api-key": Cookies.get("authToken"),
            "Content-Type": "multipart/form-data",
          },
        });
        this.$notify({
          type: "success",
          message: res.data.message,
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        this.fetchPopups(this.selectedLang, this.selectedCountry);
        this.resetForm();
      } catch (err) {
        this.$notify({
          message:
            err.response?.data?.message || err.response?.data?.error_message,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        start_date: "",
        end_date: "",
        active: "1",
        link: "",
        file: null,
      };
      this.preview = null;
      this.showForm = false;
    },
    getPopUpUrl(url) {
      if (url && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },
    async deletePopup(id) {
      if (!confirm("Are you sure you want to delete this popup?")) return;
      try {
        await axios.delete(`/popups/${id}`, {
          headers: { "api-key": Cookies.get("authToken") },
        });
        this.$notify({
          type: "success",
          message: "Deleted successfully",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        this.fetchPopups(this.selectedLang, this.selectedCountry);
      } catch (err) {
        console.error("Delete failed", err);
        this.$notify({
          type: "danger",
          message: "Delete failed",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      }
    },
    prepareEdit(popup) {
      this.editing = { ...popup };
    },
    async submitEdit() {
      try {
        await axios.put(
          `/popups/${this.editing.id}`,
          {
            start_date: this.editing.start_date,
            end_date: this.editing.end_date,
            active: this.editing.active,
            link: this.editing.link,
            language: this.selectedLang,
            country: this.selectedCountry,
          },
          {
            headers: { "api-key": Cookies.get("authToken") },
          }
        );
        this.$notify({
          type: "success",
          message: "Updated successfully",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        this.editing = null;
        this.fetchPopups(this.selectedLang, this.selectedCountry);
      } catch (err) {
        console.error("Update failed", err);
        this.$notify({
          type: "danger",
          message: "Update failed",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      }
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  z-index: 1040 !important;
}
.modal {
  z-index: 1050 !important;
  display: block;
}
</style>
